import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BreakingTicker from "@/components/feature/BreakingTicker";
import BackToTop from "@/components/feature/BackToTop";
import HeroSection from "./components/HeroSection";
import DispatchGrid from "./components/DispatchGrid";
import HotRanking from "./components/HotRanking";
import ChannelSection from "./components/ChannelSection";
import TopicSection from "./components/TopicSection";
import TestimonialSection from "./components/TestimonialSection";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";
import usePageMeta from "@/hooks/usePageMeta";
import { faqs } from "@/mocks/news";

export default function Home() {
  usePageMeta({
    title: "瓜田速递 - 突发专报与紧急插播，重大瓜情一手直达",
    description:
      "瓜田速递专注突发专报与紧急插播，重大瓜情一手直达。实时刷新最新动态与完整脉络，从重磅加急到头条专递，让你在吃瓜前线快人一步。",
    keywords: "瓜田速递,突发专报,紧急插播,重大瓜情,吃瓜前线",
    path: "/",
    type: "website",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "瓜田速递",
        alternateName: "瓜田速递 · 突发专报",
        url: "https://cllcr.cn/",
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://cllcr.cn/dispatch/breaking?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "瓜田速递",
        url: "https://cllcr.cn/",
        email: "tips@guatian-express.com",
        description: "面向泛娱乐人群的资讯速递站，提供突发专报、紧急插播、头条专递与深度瓜情。",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ],
  });

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <HeroSection />
        <BreakingTicker />
        <DispatchGrid />
        <HotRanking />
        <ChannelSection />
        <TopicSection />
        <TestimonialSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}